function spanCell(span) {
  if (span === 0) return { rowspan: 0, colspan: 0 }
  return { rowspan: span || 1, colspan: 1 }
}

const SKIP_SUM_KEYS = {
  recordId: true,
  deviceId: true,
  pageNum: true,
  pageSize: true,
  projectCategoryId: true,
  orgId: true,
  protocolId: true,
  hour: true,
  timeoutMinutes: true,
  deviceCode: true,
  terminalCode: true,
  identityKey: true,
  deviceKey: true,
  reportType: true,
  deviceType: true,
  siteType: true,
  regionName: true,
  recordStatus: true,
  deviceName: true,
  siteName: true,
  sourceSiteName: true,
  subDeviceCode: true,
  subDeviceLabel: true,
  periodLabel: true,
  reportDate: true,
  usageShare: true
}

const AVG_KEYS = {
  stdInstantAvg: true,
  workInstantAvg: true,
  pressureAvg: true,
  temperatureAvg: true,
  inletPressureAvg: true,
  outletPressureAvg: true,
  leakageAvg: true,
  signalStrengthAvg: true,
  batteryLevelAvg: true
}

const MAX_KEYS = {
  dayCount: true,
  monthCount: true
}

function toNum(value) {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

function round2(n) {
  return Math.round(n * 100) / 100
}

function sumMetricRows(rows) {
  const out = {}
  const keys = {}
  rows.forEach(row => {
    Object.keys(row || {}).forEach(key => {
      if (key.charAt(0) === '_') return
      if (SKIP_SUM_KEYS[key]) return
      keys[key] = true
    })
  })
  Object.keys(keys).forEach(key => {
    const vals = rows.map(row => toNum(row[key])).filter(v => v !== null)
    if (!vals.length) return
    if (AVG_KEYS[key]) {
      out[key] = round2(vals.reduce((a, b) => a + b, 0) / vals.length)
      return
    }
    if (MAX_KEYS[key]) {
      out[key] = Math.max.apply(null, vals)
      return
    }
    out[key] = round2(vals.reduce((a, b) => a + b, 0))
  })
  return out
}

function applyReportSpans(rows, mergeDevice) {
  let i = 0
  while (i < rows.length) {
    const site = rows[i]._siteKey
    let j = i + 1
    if (site) {
      while (j < rows.length && rows[j]._siteKey === site) j++
    }
    const span = j - i
    for (let k = i; k < j; k++) rows[k]._siteSpan = k === i ? span : 0
    i = j
  }
  if (!mergeDevice) return
  i = 0
  while (i < rows.length) {
    if (rows[i]._summaryKind === 'site') {
      rows[i]._deviceSpan = 1
      i += 1
      continue
    }
    const key = rows[i]._deviceKey
    let j = i + 1
    while (j < rows.length && rows[j]._deviceKey === key && rows[j]._summaryKind !== 'site') j++
    const span = j - i
    for (let k = i; k < j; k++) rows[k]._deviceSpan = k === i ? span : 0
    i = j
  }
}

function makeDeviceSummary(deviceRows) {
  const first = deviceRows[0]
  return Object.assign({}, first, sumMetricRows(deviceRows), {
    _summaryKind: 'device',
    _listRowKey: first._deviceKey + '|device-sum',
    _subLabel: '小计',
    _subCode: '',
    subDeviceLabel: '小计',
    subDeviceCode: '',
    recordStatus: '',
    recordId: null
  })
}

function makeSiteSummary(dataRows) {
  const first = dataRows[0]
  return Object.assign({}, first, sumMetricRows(dataRows), {
    _summaryKind: 'site',
    _listRowKey: first._siteKey + '|site-sum',
    _deviceKey: first._siteKey + '|site-sum',
    _subLabel: '合计',
    _subCode: '',
    subDeviceLabel: '合计',
    subDeviceCode: '',
    deviceName: '合计',
    recordStatus: '',
    recordId: null,
    deviceId: null,
    terminalCode: '',
    deviceCode: '',
    identityKey: ''
  })
}

function insertSummaryRows(rows) {
  const out = []
  let i = 0
  while (i < rows.length) {
    const siteKey = rows[i]._siteKey
    const deviceGroups = []
    while (i < rows.length && rows[i]._siteKey === siteKey) {
      const deviceKey = rows[i]._deviceKey
      const deviceRows = []
      while (i < rows.length && rows[i]._siteKey === siteKey && rows[i]._deviceKey === deviceKey) {
        deviceRows.push(rows[i])
        i += 1
      }
      deviceGroups.push(deviceRows)
    }
    const siteDataRows = []
    deviceGroups.forEach(deviceRows => {
      deviceRows.forEach(row => out.push(row))
      siteDataRows.push.apply(siteDataRows, deviceRows)
      if (deviceRows.length > 1) {
        out.push(makeDeviceSummary(deviceRows))
      }
    })
    if (deviceGroups.length > 1) {
      out.push(makeSiteSummary(siteDataRows))
    }
  }
  return out
}

export function reportSiteName(row) {
  if (!row) return ''
  return row.siteName || row.sourceSiteName || ''
}

export function reportDeviceName(row) {
  if (!row) return ''
  if (row._summaryKind === 'site') return '合计'
  return row.deviceName || row.deviceCode || row.terminalCode || '-'
}

export function buildReportListRows(list, options = {}) {
  const mergeDevice = options.mergeDevice !== false
  const rows = (list || []).map((row, index) => {
    const siteName = reportSiteName(row)
    const period = row.reportDate || row.periodLabel || ''
    const deviceKey = [
      period,
      row.deviceId || row.deviceKey || row.deviceCode || row.terminalCode || ('d' + index)
    ].join('|')
    return Object.assign({}, row, {
      _listRowKey: [deviceKey, row.subDeviceCode || index].join('-'),
      _siteKey: [period, siteName || ('nosite-' + deviceKey)].join('|'),
      _deviceKey: deviceKey,
      _subLabel: row.subDeviceLabel || '',
      _subCode: row.subDeviceCode || '',
      _summaryKind: ''
    })
  })
  const withSummary = mergeDevice ? insertSummaryRows(rows) : rows
  // 数据行连续序号（小计/合计行不占号），供列表序号列使用
  let dataNo = 0
  withSummary.forEach(row => {
    if (!row._summaryKind) {
      dataNo += 1
      row._dataRowNo = dataNo
    }
  })
  applyReportSpans(withSummary, mergeDevice)
  return withSummary
}

export function reportSpanMethod({ row, column }) {
  const key = column.columnKey || column.property
  if (key === 'siteName' || key === 'stationName') return spanCell(row._siteSpan)
  if (key === 'deviceName' || key === 'reportDate' || key === 'periodLabel') {
    if (row._summaryKind === 'site' && key === 'deviceName') return { rowspan: 1, colspan: 1 }
    return spanCell(row._deviceSpan)
  }
  return { rowspan: 1, colspan: 1 }
}

export function reportUsageSpanMethod({ row, column }) {
  const key = column.columnKey || column.property
  if (key === 'siteName' || key === 'stationName') return spanCell(row._siteSpan)
  return { rowspan: 1, colspan: 1 }
}

export default {
  computed: {
    reportListRows() {
      return buildReportListRows(this.list, { mergeDevice: this.reportMergeDevice !== false })
    },
    usageListRows() {
      return buildReportListRows(this.list, { mergeDevice: false })
    }
  },
  methods: {
    reportSiteName,
    reportDeviceName,
    reportSpanMethod,
    reportUsageSpanMethod,
    reportListRowKey(row) {
      return row && row._listRowKey ? row._listRowKey : undefined
    },
    reportRowClassName({ row }) {
      if (row && row._summaryKind === 'site') return 'report-summary-row is-site'
      if (row && row._summaryKind === 'device') return 'report-summary-row is-device'
      return ''
    },
    isReportSummaryRow(row) {
      return !!(row && row._summaryKind)
    }
  }
}
